import { render, staticRenderFns } from "./NotesContent.vue?vue&type=template&id=59023b16&scoped=true"
import script from "./NotesContent.vue?vue&type=script&lang=js"
export * from "./NotesContent.vue?vue&type=script&lang=js"
import style0 from "./NotesContent.vue?vue&type=style&index=0&id=59023b16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59023b16",
  null
  
)

export default component.exports